import {Treasures} from '../enums';

export function toMonsterTreasure(treasures: string[]) {
	return treasures
		.map((treasure) => Treasures[treasure] || treasure)
		.sort()
		.join(', ');
}
